export const appVersion = '1.1.47';

export const constantVariables = {
  accessToken: '_at',
  refreshToken: '_rt',
  visitorId: '_vi',
  tempToken: '_tt',
};

export const pregnancyAges = [
  { value: 1, title: 'هفته اول' },
  { value: 2, title: 'هفته دوم' },
  { value: 3, title: 'هفته سوم' },
  { value: 4, title: 'هفته چهارم' },
  { value: 5, title: 'هفته پنجم' },
  { value: 6, title: 'هفته ششم' },
  { value: 7, title: 'هفته هفتم' },
  { value: 8, title: 'هفته هشتم' },
  { value: 9, title: 'هفته نهم' },
  { value: 10, title: 'هفته دهم' },
  { value: 11, title: 'هفته یازدهم' },
  { value: 12, title: 'هفته دوازدهم' },
  { value: 13, title: 'هفته سیزدهم' },
  { value: 14, title: 'هفته چهاردهم' },
  { value: 15, title: 'هفته پانزدهم' },
  { value: 16, title: 'هفته شانزدهم' },
  { value: 17, title: 'هفته هفدهم' },
  { value: 18, title: 'هفته هجدهم' },
  { value: 19, title: 'هفته نوزدهم' },
  { value: 20, title: 'هفته بیستم' },
  { value: 21, title: 'هفته بیست و یکم' },
  { value: 22, title: 'هفته بیست و دوم' },
  { value: 23, title: 'هفته بیست و سوم' },
  { value: 24, title: 'هفته بیست و چهارم' },
  { value: 25, title: 'هفته بیست و پنجم' },
  { value: 26, title: 'هفته بیست و ششم' },
  { value: 27, title: 'هفته بیست و هفتم' },
  { value: 28, title: 'هفته بیست و هشتم' },
  { value: 29, title: 'هفته بیست و نهم' },
  { value: 30, title: 'هفته سی ام' },
  { value: 31, title: 'هفته سی و یکم' },
  { value: 32, title: 'هفته سی و دوم' },
  { value: 33, title: 'هفته سی و سوم' },
  { value: 34, title: 'هفته سی و چهارم' },
  { value: 35, title: 'هفته سی و پنجم' },
  { value: 36, title: 'هفته سی و ششم' },
  { value: 37, title: 'هفته سی و هفتم' },
  { value: 38, title: 'هفته سی و هشتم' },
  { value: 39, title: 'هفته سی و نهم' },
  { value: 40, title: 'هفته چهلم' },
  { value: 41, title: 'هفته چهل و یکم' },
  { value: 42, title: 'هفته چهل و دوم' },
];

export const startConcatString = 7;
export const finalConcatString = 14;
